<!-- <template>
  <div v-if="institutions.length > 0" class="reconnect-banner-wrap">
    <div
      v-for="inst in institutions"
      :key="inst.institutionId"
      class="reconnect-banner"
    >
      <font-awesome-icon
        :icon="['fas', 'circle-exclamation']"
        class="banner-icon"
      />
      <span class="banner-text">
        {{ inst.institutionName }} needs reconnecting
      </span>
      <button
        class="banner-action"
        :disabled="reconnectingId === inst.institutionId"
        @click="handleReconnect(inst.institutionId)"
      >
        {{ reconnectingId === inst.institutionId ? 'Opening…' : 'Reconnect' }}
      </button>
    </div>
  </div>
</template> -->
<template>
  <div v-if="items.length > 0" class="reconnect-banner-wrap">
    <div
      v-for="item in items"
      :key="item.itemId"
      class="reconnect-banner"
    >
      <font-awesome-icon :icon="['fas', 'circle-exclamation']" class="banner-icon" />
      <span class="banner-text">
        {{ item.institutionName }} needs reconnecting
      </span>
      <button
        class="banner-action"
        :disabled="reconnectingId === item.itemId"
        @click="handleReconnect(item.itemId)"
      >
        {{ reconnectingId === item.itemId ? 'Opening…' : 'Reconnect' }}
      </button>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useMyStore } from '@/store.js';

export default {
  name: 'PlaidReconnectBanner',
  setup() {
    const store = useMyStore();
    const reconnectingId = ref(null);

    const items = computed(() =>
      Object.values(store.plaidNeedsAttention || {})
    );

    // const handleReconnect = async (institutionId) => {
    //   reconnectingId.value = institutionId;
    //   try {
    //     await store.startUpdateMode(institutionId);
    //   } catch (err) {
    //     console.error('[PlaidReconnectBanner] Reconnect failed:', err);
    //   } finally {
    //     reconnectingId.value = null;
    //   }
    // };

    const handleReconnect = async (itemId) => {
      reconnectingId.value = itemId;
      try {
        await store.startUpdateMode(itemId);
      } catch (err) {
        console.error('[PlaidReconnectBanner] Reconnect failed:', err);
      } finally {
        reconnectingId.value = null;
      }
    };

    return { items, reconnectingId, handleReconnect };
  },
};
</script>

<style scoped>
.reconnect-banner-wrap {
  display: flex;
  flex-direction: column;
}

.reconnect-banner {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.6rem 1rem;
  background: rgba(127, 119, 221, 0.08);
  border-bottom: 1px solid rgba(127, 119, 221, 0.2);
  font-size: 0.85rem;
}

.dark-theme .reconnect-banner {
  background: rgba(127, 119, 221, 0.14);
  border-bottom-color: rgba(127, 119, 221, 0.3);
}

.banner-icon {
  font-size: 0.95rem;
  color: #7f77dd;
  flex-shrink: 0;
}

.banner-text {
  flex: 1;
  color: #004751;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dark-theme .banner-text {
  color: #ffffff;
}

.banner-action {
  flex-shrink: 0;
  border: none;
  border-radius: 50px;
  padding: 0.32rem 0.85rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  background: linear-gradient(135deg, #7f77dd, #5dcaa5);
  color: white;
  cursor: pointer;
  transition:
    transform 0.15s,
    opacity 0.15s;
}

.banner-action:hover:not(:disabled) {
  transform: translateY(-1px);
}

.banner-action:active:not(:disabled) {
  transform: scale(0.97);
}

.banner-action:disabled {
  opacity: 0.6;
  cursor: wait;
}
</style>
